import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RxIconComponent } from '../rx-icon/rx-icon.component';
import { RxIconModule } from '@nrwl/rx-icon';
import { RxSearchComponent } from './rx-search.component';
import { RxUiModule } from '../rx-ui.module';

@NgModule({
  imports: [CommonModule, FormsModule, RxUiModule, RxIconModule, RxSearchComponent],
  exports: [RxSearchComponent],
})
export class RxSearchModule {}
